export default __webpack_public_path__ + "static/media/laptop-home.e3390a30.svg";